import React from "react";
import { Link } from "react-router-dom";

const GoToContent = ({ withDelimiter }) => {
  return (
    <>
      {withDelimiter && (
        <hr className="w-full border-gray-500 border-b-1 my-8" />
      )}

      <div className="flex flex-col justify-center items-center px-8">
        <Link
          to="/home"
          className={`bg-orange-brand-500 hover:bg-gray-900 rounded text-white py-4 px-4`}
        >
          GO TO CONTENT
        </Link>
      </div>
    </>
  );
};

export default GoToContent;
